import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 10a7.31 7.31 0 0 0 10 10Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m9 15 3-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 13a6 6 0 0 0-6-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 13A10 10 0 0 0 11 3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SatelliteDish";
const SatelliteDish = memo(themed(Icon));
export {
  SatelliteDish
};
//# sourceMappingURL=satellite-dish.js.map
